import React, { useState } from 'react';
import AuthorInfoCard from './AuthorInfoCard';
import { AuthorBlogCard } from './AuthorBlogCard';
import { LoadingSpinner } from '../../shared-components/LoadingSpinner/LoadingSpinner';
import { AuthorProps } from '../../types/pages/author';
import { useRouter } from 'next/router';
import Breadcrumb from '../../shared-components/Breadcrumb/Breadcrumb';

export const Author: React.FC<AuthorProps> = ({ authorData }) => {
  const router = useRouter();
  const authorId = router.query.id as string;

  const [visibleCount, setVisibleCount] = useState(4);
  const [isLoading, setIsLoading] = useState(false);
  const showMoreBlogs = () => {
    setIsLoading(true);
    setTimeout(() => {
      setVisibleCount(authorData.blogs.length);
      setIsLoading(false);
    }, 500);
  };
  const breadcrumbLinks = [
    { title: 'Home', hrefLink: '/' },
    { title: 'Blogs', hrefLink: '/blog' },
    { title: authorData.name, hrefLink: `/author/${authorId}` }
  ];
  return (
    <div className="flex flex-col">
      <div className="bg-grayFA py-12 lg:pb-[98px] lg:pt-[50px]">
        <div className="w-full px-5 xsm:px-7 sm:px-0 md:w-[85%] lg:w-[80%] 2xl:w-[80%] 3xl:w-[70%] 4xl:w-[60%] flex flex-col mx-auto">
          <div className="mb-8">
            <Breadcrumb
              breadcrumbLinks={breadcrumbLinks}
              alignContent="justify-start"
              isArrowSeparator={true}
            />
          </div>
          <div className="w-full flex flex-col lg:flex-row gap-14 mx-auto sm:items-center xl:items-start">
            <div className="w-full sm:w-fit">
              <AuthorInfoCard authorData={authorData} />
            </div>
            <div className="w-full lg:w-[70%] flex flex-col gap-14 mr-12 ">
              <div className="flex flex-col gap-3">
                <h2 className="text-black13 text-xl lg:text-[22px] font-semibold">
                  About
                </h2>
                <p className="text-gray75 text-[14px] md:text-base text-justify leading-[30px]">
                  {authorData.bio}
                </p>
              </div>
              <div className="flex flex-col gap-3">
                <h2 className="text-black13 text-xl lg:text-[22px] font-semibold">
                  More Info
                </h2>
                <p className="text-gray75 text-[14px] md:text-base text-justify leading-[30px]">
                  {authorData.additionalInfo}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-10 sm:py-10 flex flex-col gap-5 lg:gap-9 px-5 xsm:px-7 sm:px-0 w-full md:w-[85%] lg:w-[80%] 2xl:w-[80%] 3xl:w-[70%] 4xl:w-[60%] mx-auto">
        <h2 className="text-black13 text-xl lg:text-[32px] leading-[50px] font-semibold">
          Recently Published By {authorData.name}
        </h2>
        {authorData?.blogs?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-[30px] thin-scrollbar overflow-auto max-h-[650px]">
            {authorData?.blogs?.slice(0, visibleCount).map((blog: any) => (
              <AuthorBlogCard
                key={blog.id}
                blog={blog}
                authorName={authorData.name}
                authorImage={authorData.image}
              />
            ))}
          </div>
        ) : (
          <div>
            {`Looks like this author hasn't added any blogs yet. Check back
            soon for updates!`}
          </div>
        )}

        <div className="flex justify-center">
          {visibleCount < authorData?.blogs?.length && (
            <button
              className="bg-primary hover:bg-[#2E3D7A] active:bg-[#2E3D7A] text-white rounded-full px-6 py-2"
              onClick={showMoreBlogs}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center">
                  <LoadingSpinner className="w-4 h-4 mr-2 inline-block border-white" />
                  <p>Loading...</p>
                </div>
              ) : (
                'Explore More'
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
